import React, { FC } from 'react';
import { iconSize } from '../../../../../constants/icon.constants';
import DictionaryTerm from '../../../dictionaryTerm';
import Icon from '../../../icon';
import './styles.scss';

export type TNoMatchProps = Partial<{
  extraClassName: string;
  titleDictionaryKey: string;
  descriptionDictionaryKey: string;
}>;

const NoMatch: FC<TNoMatchProps> = ({ extraClassName = '', titleDictionaryKey = '', descriptionDictionaryKey = '' }) => {
  return (
    <div className={`${extraClassName} filter-no-match`}>
      <Icon iconName="action-close-circle" size={iconSize['xlg']} extraClassName="filter-no-match__icon" />
      {titleDictionaryKey && (
        <p className="filter-no-match__title">
          <DictionaryTerm keyword={titleDictionaryKey} />
        </p>
      )}
      <p className="filter-no-match__description">
        <DictionaryTerm keyword={descriptionDictionaryKey} />
      </p>
    </div>
  );
};

export default NoMatch;
